import { createClient } from '@dev-togetherprice/auth-client';
import SecureStorage from './storage';

const client = createClient(process.env.REACT_APP_UMS, {
  storage: SecureStorage,
});

export default client;
